export default __webpack_public_path__ + "static/media/IC00052-chat.45626d01.svg";